'use client'

import { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { Reveal } from '../Reveal'
import { CloseIcon } from '../Icons'
import { gallery } from '@/lib/site-config'

export function Gallery(): React.ReactElement {
  const [active, setActive] = useState<number | null>(null)

  return (
    <section id="gallery" className="section-pad relative overflow-hidden bg-charcoal-900">
      <div className="container-x relative">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="eyebrow mb-5">معرض الأعمال</span>
          <h2 className="font-heading text-3xl font-extrabold text-white sm:text-4xl md:text-5xl">
            نماذج <span className="gold-text">توضيحية</span>
          </h2>
          <p className="mt-5 text-lg text-charcoal-300">
            الصور التالية نماذج توضيحية لأنواع الأعمال، وقابلة للاستبدال بأعمالنا الحقيقية مستقبلًا.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
          {gallery.map((item, i) => (
            <motion.button
              type="button"
              key={item.src}
              onClick={() => setActive(i)}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
              className={`group relative overflow-hidden rounded-2xl border border-white/5 ${
                i % 5 === 0 ? 'col-span-2 row-span-2' : ''
              }`}
            >
              <img
                src={item.src}
                alt={item.alt}
                loading="lazy"
                className="h-full min-h-[160px] w-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal-950/80 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              <span className="absolute bottom-3 right-3 rounded-md bg-charcoal-950/70 px-2.5 py-1 text-xs font-semibold text-gold-200 opacity-0 backdrop-blur transition-opacity duration-300 group-hover:opacity-100">
                نموذج توضيحي
              </span>
            </motion.button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {active !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            className="fixed inset-0 z-[60] flex items-center justify-center bg-charcoal-950/95 p-4 backdrop-blur"
          >
            <button
              type="button"
              aria-label="إغلاق"
              className="absolute right-5 top-5 inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/20 text-white transition-colors hover:bg-white/10"
              onClick={() => setActive(null)}
            >
              <CloseIcon className="h-6 w-6" />
            </button>
            <motion.img
              key={gallery[active].src}
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              src={gallery[active].src}
              alt={gallery[active].alt}
              onClick={(e) => e.stopPropagation()}
              className="max-h-[85vh] max-w-full rounded-2xl border border-gold-500/20 object-contain shadow-card"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  )
}
